<template>
  <div class="relative inline-block text-left">
    <div
      class="world-button"
      @click="changeDropdown"
    >
      <span class="mr-1">{{ selectedWorld !== 'All' ? selectedWorld : translations.World }}</span>
      <ChevronDown />
    </div>
    <span
      class="all-worlds"
      v-if="selectedWorld !== 'All'"
      @click="resetFilter"
    >
      <ArrowRight class="mr-2" />
      {{ translations.SeeAllWorlds }}
    </span>
    <div
      class="worlds-dropdown"
      :class="{
        hidden: !dropdownOpen
      }"
    >
      <ul
        class="world-dropdown-container"
      >
        <li
          v-for="(world, index) in worlds"
          :key="index"
          class="world my-2"
          :class="{
            selected: world === selectedWorld
          }"
          @click="changeFilterWorld(world)"
        >
          <span>
            {{ world !== 'All' ? world : translations.World }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ChevronDown from '@/components/ChevronDown.vue'
import ArrowRight from '@/components/ArrowRight.vue'
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'FilterWorld',
  data () {
    return {
      dropdownOpen: false
    }
  },
  components: {
    ChevronDown,
    ArrowRight
  },
  computed: {
    ...mapState(['filter', 'worlds', 'selectedWorld', 'translations'])
  },
  methods: {
    ...mapMutations(['changeFilter', 'changeWorld']),
    changeDropdown () {
      this.dropdownOpen = !this.dropdownOpen
    },
    changeFilterWorld (value) {
      this.changeWorld(value)
      this.changeFilter(value)
      this.changeDropdown()
    },
    resetFilter () {
      this.changeWorld('All')
      this.changeFilter('All')
    }
  }
}
</script>

<style>
.world-button {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 248, 248, var(--tw-bg-opacity));
  border-radius: 1rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  -webkit-justify-content: space-between;
  justify-content: space-between;
  font-weight: 700;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  --tw-text-opacity: 1;
  color: rgba(50, 51, 147, var(--tw-text-opacity));
  width: 300px;
}
.world-dropdown-container {
  --tw-bg-opacity: 1;
  background-color: rgba(248, 248, 248, var(--tw-bg-opacity));
  border-radius: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  position: absolute;
  top: 16px;
  --tw-shadow-color: 0, 0, 0;
  --tw-shadow: 0 4px 6px -1px rgba(var(--tw-shadow-color), 0.1), 0 2px 4px -1px rgba(var(--tw-shadow-color), 0.06);
  -webkit-box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-text-opacity: 1;
  color: rgba(141, 141, 141, var(--tw-text-opacity));
  width: 300px;
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform, filter, backdrop-filter;
  -o-transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, -webkit-box-shadow, transform, -webkit-transform, filter, backdrop-filter;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  -webkit-transition-duration: 100ms;
  -o-transition-duration: 100ms;
  transition-duration: 100ms;
}
.world-dropdown-container .selected {
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgba(50, 51, 147, var(--tw-text-opacity));
}
.worlds-dropdown {
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform, filter, backdrop-filter;
  -o-transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, -webkit-box-shadow, transform, -webkit-transform, filter, backdrop-filter;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  -webkit-transition-duration: 100ms;
  -o-transition-duration: 100ms;
  transition-duration: 100ms;
}
.worlds-dropdown.hidden {
  -webkit-transition-property: background-color, border-color, color, fill, stroke, opacity, -webkit-box-shadow, -webkit-transform, filter, backdrop-filter;
  -o-transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, -webkit-box-shadow, transform, -webkit-transform, filter, backdrop-filter;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  -webkit-transition-duration: 75ms;
  -o-transition-duration: 75ms;
  transition-duration: 75ms;
}
.all-worlds:hover {
  cursor: pointer;
}
.all-worlds {
  font-weight: 700;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin-left: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(254, 195, 62, var(--tw-text-opacity));
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
}
.world-button:hover, .world:hover {
  cursor: pointer;
}
</style>
